import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
    } catch {}
    // Always show success — never reveal if email exists
    setSubmitted(true);
    setLoading(false);
  };

  return (
    <div className="co-scope min-h-screen flex items-center justify-center p-4" style={{ background: 'radial-gradient(1200px 600px at 50% -10%, #0a2233 0%, #041019 55%, #020b11 100%)' }}>
      <Card className="w-full max-w-md bg-[#081a25] border border-[#193b4b]" data-testid="forgot-password-page">
        <CardHeader className="text-center">
          <img src="/cipherone-logo.png" alt="CipherOne" className="w-12 h-12 object-contain mx-auto mb-2" />
          <CardTitle className="text-xl text-[#f4f8fa]">Reset Your Password</CardTitle>
          <CardDescription className="text-[#b1c3ce]">Enter your email address and we'll send you a reset link</CardDescription>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <div className="text-center space-y-4 py-4">
              <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
              <p className="text-sm text-gray-700">
                If that email is registered, a password reset link has been sent. Please check your inbox.
              </p>
              <Button variant="outline" onClick={() => navigate('/login')} className="mt-4">
                <ArrowLeft className="h-4 w-4 mr-2" /> Back to Sign In
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email Address</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-btn">
                <Mail className="h-4 w-4 mr-2" />
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <div className="text-center">
                <button type="button" className="text-sm text-blue-600 hover:underline" onClick={() => navigate('/login')}>
                  Back to Sign In
                </button>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
